<template>
    <div class="page-head">
        <div class="container">
            <div class="row">
                <div class="page-head-content">
                    <h1 class="page-title"><span class="orange strong">{{agencyId ? agency ? 'Edit Agency: ' + agency.name : 'Edit Agency: ' : 'You are not joined to agency yet'}}</span></h1>
                </div>
            </div>
        </div>
    </div>

    <div class="content-area user-profiel"  >&nbsp;
        <div class="container">
            <div class="row" v-if="!agencyId">
                <div class="col-md-12 alert-message">
                    <p><i class="fa fa-exclamation-triangle"></i> <span>You are not joined to agency! to be part of an agency either create your first ad or search of specific agency in <router-link to="/agency-search">agency search</router-link> and join it</span></p>
                </div>
            </div>

            <div v-else>
                <div class="row" v-if="!loading && agency">
                    <div class="col-sm-10 col-sm-offset-1 profiel-container">
                        <form action="#" method="post" @submit.prevent="submit" enctype="multipart/form-data">
                            <div class="clear">

                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label>Agency Name <small>(required)</small></label>
                                        <input name="name" type="text" class="form-control" placeholder="Andrew..." v-model="form.name" />
                                        <span class="invalid-feedback" v-if="errors && errors.name">{{errors.name[0]}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label>Email <small>(required)</small></label>
                                        <input name="email" type="email" class="form-control" placeholder="andrew@email@email.com" v-model="form.email" />
                                        <span class="invalid-feedback" v-if="errors && errors.email">{{errors.email[0]}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label>Phone :</label>
                                        <input name="phone" type="tel" class="form-control" placeholder="+1 9090909090" v-model="form.phone" />
                                        <span class="invalid-feedback" v-if="errors && errors.phone">{{errors.phone[0]}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label>Address</label>
                                        <input name="address" type="text" class="form-control" placeholder="" v-model="form.address" />
                                        <span class="invalid-feedback" v-if="errors && errors.address">{{errors.address[0]}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label><i class="fa fa-globe"></i> Website</label>
                                        <input name="website" type="url" class="form-control" placeholder="https://" v-model="form.website" />
                                        <span class="invalid-feedback" v-if="errors && errors.website">{{errors.website[0]}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label><i class="fa fa-facebook"></i> Facebook</label>
                                        <input name="facebook" type="url" class="form-control" placeholder="https://" v-model="form.facebook" />
                                        <span class="invalid-feedback" v-if="errors && errors.facebook">{{errors.facebook[0]}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label><i class="fa fa-twitter"></i> Twitter</label>
                                        <input name="twitter" type="url" class="form-control" placeholder="https://" v-model="form.twitter" />
                                        <span class="invalid-feedback" v-if="errors && errors.twitter">{{errors.twitter[0]}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 padding-top-25">
                                    <div class="form-group">
                                        <label><i class="fa fa-google"></i> Google</label>
                                        <input name="google" type="url" class="form-control" placeholder="https://" v-model="form.google" />
                                        <span class="invalid-feedback" v-if="errors && errors.google">{{errors.google[0]}}</span>
                                    </div>
                                </div>

                                <div class="col-sm-12 padding-top-25">
                                    <div class="form-group">
                                        <label><i class="fa fa-sticky-note"></i> Bio</label>
                                        <textarea name="bio" class="form-control" rows="5" v-model="form.bio"></textarea>
                                        <span class="invalid-feedback" v-if="errors && errors.bio">{{errors.bio[0]}}</span>
                                    </div>

                                    <div class="form-group">
                                        <label><i class="fa fa-upload"></i> Picture</label>
                                        <input type="file" name="picture" class="form-control" accept="image/png, image/jpeg, image/gif" @change="handlePicture" />
                                        <span class="invalid-feedback" v-if="errors && errors.picture">{{errors.picture[0]}}</span>
                                        <img :src="agency.picture_url" v-if="agency.picture_url" width="200" height="180" />
                                    </div>
                                </div>

                                <div class="col-sm-5 col-sm-offset-6">
                                    <br>
                                    <input type='submit' class='btn btn-finish btn-primary' name='finish' value='Update' />
                                </div>
                                <br>

                            </div>
                        </form>
                    </div>
                </div>

                <div class="row" v-else>
                    <div class="col-md-12">
                        <div class="fa-3x">
                            <i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useAuthStore} from "../../../store/auth";
import {reactive, ref} from "vue";
import {useToast} from "vue-toastification";
import {useRouter} from "vue-router";

export default {
    name: "EditAgency",
    setup() {
        const router = useRouter();
        const toast = useToast();
        const authStore = useAuthStore();

        const agencyId = authStore.$state.user.agency_id;

        if(!agencyId) {
            router.push('/');
        }

        const agency = ref(null);
        const loading = ref(false);

        const form = reactive({
           name: '',
           email: '',
           phone: '',
            address: '',
            website: '',
            facebook: '',
            twitter: '',
            google: '',
            bio: ''
        });

        let formData = new FormData();

        const errors = ref(null);

        function getAgencyDetails() {
            if(!agencyId) {
                return;
            }

            loading.value = true;

            window.axios.get(`/api/agency/${agencyId}`).then(response => {
                loading.value = false;

                if(response.data.agency.agency_owner_id !== authStore.$state.user.id) {
                    router.push('/');
                }

                agency.value = response.data.agency;

                form.name = agency.value.name;
                form.email = agency.value.email;
                form.phone = agency.value.phone;
                form.address = agency.value.address;
                form.website = agency.value.website;
                form.facebook = agency.value.facebook;
                form.twitter = agency.value.twitter;
                form.google = agency.value.google;
                form.bio = agency.value.bio;
            }).catch(err=> {
                loading.value = false;
            });
        }

        getAgencyDetails();

        function submit() {
            toFormData();
            formData.append('agency_id', agencyId);
            formData.append('_method', 'PUT');

            window.axios.post(`/api/agency/${agencyId}`, formData, {
                headers: {
                   // 'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
               toast.success(response.data.message);
               agency.value = response.data.agency;
            }).catch(err => {
                console.error(err);

                toast.error(response.data.message);
            });
        }

        function toFormData() {
            const payload = {...form};

            for(let key in payload) {
                formData.append(key, payload[key] ? payload[key] : '');
            }
        }

        function handlePicture(ev) {
            if(!ev.target.files) {
                return;
            }

            formData.append('picture', ev.target.files[0]);
        }

        return {
            agency,
            loading,
            agencyId,
            submit,
            form,
            errors,
            handlePicture
        }
    }
}
</script>

<style scoped>

</style>
